import React, { useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import {
  PiCrownSimpleDuotone,
  PiCoinsDuotone,
} from "react-icons/pi";
import { FiEye } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";
import ProtectedCanvasImage from "../../components/ProtectedCanvasImage";

const Favorites = () => {
  const navigate = useNavigate();

  const [wishlist, setWishlist] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  /* =====================================================
     FETCH WISHLIST
     ===================================================== */
  const fetchWishlist = async () => {
    try {
      const res = await api.get(
        `/custwishroutes/wishlist/customer`
      );

      setWishlist(
        res.data.data || []
      );
    } catch (error) {
      console.error(
        "Failed to fetch wishlist:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, []);

  return (
    <>
      <Row className="mx-0 breadcrumb_part">
        <Col
          md={12}
          className="prof_title mb-4"
        >
          <h4>Favorites</h4>
        </Col>
      </Row>

      <Row>
        {loading ? (
          <p className="text-center">
            Loading favorites...
          </p>
        ) : wishlist.length ===
          0 ? (
          <p className="text-center text-muted">
            No products in your
            wishlist
          </p>
        ) : (
          <ul className="favDiv">
            {wishlist.map((item) => {
              const product =
                item.product;

              const image =
                product?.thumbnail
                  ?.image_url ||
                "/placeholder.png";

              const productUrl =
                `/product_details/${product?.product_id}`;

              return (
                <li
                  key={
                    item.wishlist_id
                  }
                >
                  <Card className="card-click">
                    <ProtectedCanvasImage
                      src={image}
                      alt={
                        product?.product_name ||
                        "Product"
                      }
                      width="100%"
                      height={220}
                      objectFit="cover"
                      objectPosition="top center"
                      onClick={() =>
                        navigate(
                          productUrl
                        )
                      }
                    />

                    {product?.is_featured && (
                      <div className="prime_icon">
                        <PiCrownSimpleDuotone />
                      </div>
                    )}

                    <div className="imageoption">
                      <div className="buttonlist">
                        <div
                          className="view"
                          title="View"
                          onClick={() =>
                            navigate(
                              productUrl
                            )
                          }
                        >
                          <FiEye />
                        </div>
                      </div>
                    </div>

                    <div className="product-title favtitle">
                      <p
                        onClick={() =>
                          navigate(
                            productUrl
                          )
                        }
                      >
                        {
                          product.product_name
                        }
                      </p>

                      <div className="d-flex justify-content-between align-items-center favcoinsec">
                        <span
                          className="text-pink"
                          title="Credits"
                        >
                          <PiCoinsDuotone />{" "}
                          {product.credit_cost ||
                            0}
                        </span>
                      </div>
                    </div>
                  </Card>
                </li>
              );
            })}
          </ul>
        )}
      </Row>
    </>
  );
};

export default Favorites;